import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import Company from "./company";
import Values from "./values";
import PersonalInfo from "./PersonalInfo";
import { useEffect } from "react";

const SME = ({ values, onChange }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!values.company_name) return navigate("/valuation-game/sme/company");
    if (!values.valuation_game_ca || !values.valuation_game_ebe) return navigate("/valuation-game/sme/values");
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to={"./company"} />} />
      <Route path="/company" element={<Company values={values} onChange={onChange} />} />
      <Route path="/values" element={<Values values={values} onChange={onChange} />} />
      <Route path="/personal-info" element={<PersonalInfo values={values} onChange={onChange} />} />
    </Routes>
  );
};

export default SME;
